export const TOKEN_KEY = 'bf_admin_token';
export const FIGMA_TOKEN_KEY = 'bf_figma_token';
export const FIGMA_REFRESH_TOKEN_KEY = 'bf_figma_refresh_token';
